import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ISPFieldType } from 'common/dynamic-form/model';

import { LayoutBaseComponent } from '../layout-base.component';

/**
 * Extform layout of dynamic form component. Using on logon and potentially on extform.
 * Assumed that it should be on top level
 */
@Component({
  selector: 'isp-formly-extform-layout-field',
  templateUrl: './extform-layout.component.html',
  styleUrls: ['./scss/extform-layout.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtformLayoutComponent extends LayoutBaseComponent<ISPFieldType.ExtformLayout> {}
